module.exports = __webpack_public_path__ + "static/media/Havraniky.fc60f83f.md";